"use client";

import DeviceProvider from "@/app/redux/features/device/DeviceProvider";
import WinPageContent from "./page-content";

const BotbWinPage = () => {
  return (
    <DeviceProvider>
      <WinPageContent />
    </DeviceProvider>
  );
};

export default BotbWinPage;
